<template>
  <div class="app-wrapper">
    <!-- 左侧菜单栏 -->
    <div class="sidebar-container">
      <Sidebar />
    </div>

    <!-- 右侧内容区域 -->
    <div class="main-container">
      <div class="navbar">
        <Navbar />
      </div>
      <div class="breadcrumb-container">
        <Breadcrumb />
      </div>
      <AppMain />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Breadcrumb,
  },
  created() {
  },
  methods: {
  
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;

  .sidebar-container {
    width: 210px;
    height: 100%;
    background: #304156;
    transition: width 0.28s;
    overflow-y: auto;
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;

    .navbar {
      height: 50px;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    }

    .breadcrumb-container {
      height: 40px;
      background: #fff;
      border-bottom: 1px solid #e6e6e6;
      padding: 0 20px;
    }

    .app-main {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
      background: #f0f2f5;
    }
  }
}
</style>
